export default {
  'miner.title': '👥 Quản lý Thợ đào',
  'miner.subtitle': 'Danh sách tất cả người dùng tham gia hệ sinh thái COW',
  'miner.headerTitle': 'Danh sách thợ đào',
  'miner.copySuccess': 'Đã sao chép!',
  'miner.walletAddress': 'Địa chỉ ví',
  'miner.userId': 'User ID',
  'miner.socialLinks': 'Mạng xã hội',
  'miner.miningStatus': 'Trạng thái Mining',
  'miner.createdAt': 'Ngày tạo',
  'miner.action': 'Thao tác',
  'miner.detail': 'Chi tiết',
  'miner.status.ready': 'Sẵn sàng',
  'miner.status.needSocial': 'Cần liên kết MXH',
  'miner.social.x.verified': 'X: Đã xác minh',
  'miner.social.x.unverified': 'X: Chưa xác minh',
  'miner.social.x.notLinked': 'X: Chưa liên kết',
  'miner.social.telegram.verified': 'Telegram: Đã xác minh',
  'miner.social.telegram.unverified': 'Telegram: Chưa xác minh',
  'miner.social.telegram.notLinked': 'Telegram: Chưa liên kết',
  'miner.status.active': 'Đang hoạt động',
  'miner.status.blocked': 'Đã bị khóa',
  'miner.status.restricted': 'Hạn chế',
  'miner.status.all': 'Tất cả',
  'miner.status.title': 'Trạng thái',
  'miner.action.block': 'Khóa',
  'miner.action.unblock': 'Bỏ khóa',
  'miner.action.restrict': 'Hạn chế',
  'miner.confirm.block': 'Khóa tài khoản này? Người dùng sẽ không thể làm gì.',
  'miner.confirm.unblock': 'Mở khóa tài khoản này?',
  'miner.confirm.restricted': 'Hạn chế tài khoản? Chỉ được đào, không được gửi/mở khóa.',
  'miner.updateSuccess': 'Cập nhật trạng thái thành công!',
  'miner.updateFailed': 'Cập nhật thất bại, vui lòng thử lại.',
  'miner.approval.title': 'Duyệt yêu cầu',
  'miner.approval.subtitle': 'Quản lý các yêu cầu giao dịch từ tài khoản bị hạn chế',
  'miner.approval.actionType': 'Loại hành động',
  'miner.approval.payload': 'Dữ liệu',
  'miner.approval.status': 'Trạng thái',
  'miner.approval.pending': 'Chờ duyệt',
  'miner.approval.approved': 'Đã duyệt',
  'miner.approval.rejected': 'Đã từ chối',
  'miner.approval.confirmApprove': 'Bạn có chắc chắn muốn duyệt yêu cầu này?',
  'miner.approval.confirmReject': 'Bạn có chắc chắn muốn từ chối yêu cầu này?',
  'miner.approval.approveSuccess': 'Đã duyệt yêu cầu thành công!',
  'miner.approval.rejectSuccess': 'Đã từ chối yêu cầu!',
  'miner.approval.approveFailed': 'Duyệt yêu cầu thất bại.',
  'miner.approval.modal.title': 'Gửi thông báo cho người dùng',
  'miner.approval.modal.msgVi': 'Lời nhắn (Tiếng Việt)',
  'miner.approval.modal.msgEn': 'Lời nhắn (Tiếng Anh)',
  'miner.approval.modal.placeholder': 'Nhập nội dung thông báo...',
  'miner.approval.modal.submit': 'Xác nhận & Gửi',
  'miner.approval.modal.skip': 'Chỉ cập nhật trạng thái (Không gửi thông báo)',
  'miner.approval.modal.cancel': 'Hủy',
  'miner.approval.modal.processing': 'Đang thực hiện:',
  'miner.approval.modal.sendTo': 'Gửi tới ví:',
  'miner.approval.modal.approveText': 'PHÊ DUYỆT',
  'miner.approval.modal.rejectText': 'TỪ CHỐI',
  'miner.approval.modal.ruleMsgVi': 'Vui lòng nhập lời nhắn tiếng Việt',
  'miner.approval.modal.ruleMsgEn': 'Vui lòng nhập lời nhắn tiếng Anh',
  'miner.approval.modal.defaultApproveVi': 'Yêu cầu của bạn đã được phê duyệt và tài khoản đã được mở khóa.',
  'miner.approval.modal.defaultRejectVi': 'Rất tiếc, yêu cầu của bạn đã bị từ chối.',
  'miner.approval.modal.defaultApproveEn': 'Your request has been approved and your account is now unlocked.',
  'miner.approval.modal.defaultRejectEn': 'Sorry, your request has been rejected.',
  'miner.approval.approve': 'Duyệt',
  'miner.approval.reject': 'Từ chối',
  'miner.approval.action.unlock': 'Mở khóa chuyển tiền',
};
